import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, Input, OnDestroy } from '@angular/core';


import { SportConfigToken } from '@config/sport.config';

import { TranslateService } from '@ngx-translate/core';

import { OptaWidgetBase } from '../base.service';

declare const Opta: any;

@Component({
    selector: 'app-opta-attacking-thirds',
    templateUrl: './attacking-thirds.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptaWidgetAttackingThirdsComponent extends OptaWidgetBase implements AfterViewInit, OnDestroy {
    @Input()
        matchId: string | number | null | undefined;

    @Input()
        competitionId: string | number | null | undefined;

    @Input()
        seasonId: string | number | null | undefined;

    #headlineTrans = 'web.opta_attacking_thirds';
    private transHeadline = '';


    public constructor(@Inject(SportConfigToken) public sportConfig: Record<string, any>,
        public translate: TranslateService) {
        super();
    }

    public ngAfterViewInit(): void {
        this.transHeadline = this.translate.instant(this.#headlineTrans);
        setTimeout(() => {
            const element = document.querySelector('#opta-attacking-thirds') as HTMLElement;

            if (element) {
                element.innerHTML = this.getHtml();
                const optaWidgetTags = document.querySelector('opta-widget[load="false"]');

                if (optaWidgetTags) {
                    optaWidgetTags.removeAttribute('load');
                    Opta.start();
                }
            }
        });
    }

    ngOnDestroy(): void {
        if (Opta.widgets.ref_widget_attacking_thirds) {
            Opta.widgets.ref_widget_attacking_thirds.destroy(true);
        }
    }

    getHtml(): string {
        return `
            <opta-widget  widget_id="ref_widget_attacking_thirds" widget="attacking_thirds"
          competition="${this.competitionId}" season="${this.seasonId}" match="${this.matchId}"  load="false"
            template="normal" live="true" orientation="horizontal" side="both"
            half_pitch="false" one_direction="false" navigation="tabs_more" animation="false"
            show_match_header="false" show_halftime_score="false" show_crests="false" show_pitch_crests="false"
            show_competition_name="false" show_timecontrols="true" proportional_arrows="false"
          competition_naming="full"
            team_naming="full"
            show_date="false" date_format="dddd D MMMM YYYY" narrow_date_format="DD/MM/YY"
            show_logo="false" title="${this.transHeadline}" show_title="true" show_live="true" breakpoints="400, 700"
             sport="football"></opta-widget>
            `;
    }
}
